<script>
import HeaderPage from "@/components/common/header.vue"
import FooterPage from "@/components/common/footer.vue"
import MenuPage from "@/components/common/menu.vue"

export default {
  name: "baseLayout",
  components: {HeaderPage, FooterPage, MenuPage}
}
</script>

<template>
  <el-container>
    <el-header>
      <HeaderPage></HeaderPage>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <MenuPage></MenuPage>
      </el-aside>
      <el-container>
        <el-main>
          <router-view></router-view>
        </el-main>
        <el-footer>
          <FooterPage></FooterPage>
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<style scoped>
.el-container {
  height: 100vh;
  display: flex;
}
.el-container > .el-container {  /* 选择第二层容器 */
  height: 100%;
  flex: 1;
  min-height: 0; /* 修复Safari浏览器flex布局问题 */
}
.el-container .el-header, .el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  padding: 0;
  line-height: 40px !important;
  height: 40px !important;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  line-height: 50px;
  flex: 1;
  overflow: auto; /* 内容溢出时显示滚动条 */
}
</style>